import { Reducer } from "redux";
import ContractsCountState from "./ContractsCountState";
import { ContractsCountAction, ContractsCountActionTypes } from "./ContractsCountActions";

const initialState: ContractsCountState = {
  contractsCount: []
}

const ContractsCountReducer: Reducer<ContractsCountState, ContractsCountAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ContractsCountActionTypes.SET_CONTRACTS_COUNT: {
      return {
        ...state,
        contractsCount: [...action.data],
      };
    }
    default: {
      return state;
    }
  }
};

export default ContractsCountReducer;